<template>
  <div class="settings">
    <div class="head">
      <el-button
        v-show="!hideBack"
        type="text"
        icon="el-icon-arrow-left"
        class="back"
        @click="back"
        >返回</el-button
      >
      <el-steps :active="activeStep" align-center finish-status="success">
        <el-step title="班级考核权重设置"></el-step>
        <el-step title="个人章节考核权重设置"></el-step>
        <el-step title="团队章节考核权重设置"></el-step>
        <el-step title="实战技能考核权重设置" v-if="classInfo.douyin"></el-step>
      </el-steps>
    </div>

    <div class="main">
      <!-- 班级权重考核 -->
      <div class="class-weight" v-if="activeStep == 0">
        <div class="one-weight" v-for="(item, idx) in weightItems" :key="idx">
          <span class="weight-name">{{ item.name }}:</span>
          <el-input-number
            size="small"
            v-model="form[item.text]"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip placement="top">
              <div slot="content">
                <span v-html="item.tips"></span>
                <span
                  style="color: #1890ff"
                  v-if="item.more"
                  v-html="item.more"
                ></span>
              </div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">知识考核平均分:</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,班级学生个人知识成绩平均分"
              ><i class="el-icon-info"></i
            ></el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">态度考核平均分:</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,班级学生个人态度成绩平均分"
              ><i class="el-icon-info"></i
            ></el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">技能考核平均分:</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,班级学生个人技能成绩平均分"
              ><i class="el-icon-info"></i
            ></el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">素养考核平均分:</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,班级学生个人素养成绩平均分"
              ><i class="el-icon-info"></i
            ></el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">雷达图:</span>
          <p class="tips">
            <span class="total"
              >包含班级学生态度、知识、技能、素养四个维度均值</span
            >
          </p>
        </div>
      </div>

      <!-- 个人章节考核权重设置 -->
      <div class="personal-chapter-weight" v-if="activeStep == 1">
        <div class="one-weight">
          <span class="weight-name">个人章节态度成绩:</span>
          <el-input-number
            size="small"
            v-model="form.personalTdRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,个人章节态度成绩=100/活动总个数*个人执行活动个数"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
          <div class="weight-content">
            <el-checkbox v-model="form.personalEnableVideo"
              >必须完成项: 视频全部看完1次</el-checkbox
            >
            <el-checkbox v-model="form.personalEnablePpt"
              >必须完成项: PPT全部看完1次(看到最后一张)</el-checkbox
            >
            <el-checkbox v-model="form.personalEnableSign"
              >必须完成项: 签到1次</el-checkbox
            >
            <el-checkbox v-model="form.personalEnableNotes"
              >必须完成项:笔记记录保存1次</el-checkbox
            >
            <el-checkbox v-model="form.personalEnableWorks"
              >必须完成项(如果有): 作品提交1次</el-checkbox
            >
            <el-checkbox v-model="form.personalEnableWorksInteract"
              >必须完成项(如果有):
              作品互动1次(点赞、留言、评分任何一个动作)</el-checkbox
            >
            <el-checkbox v-model="form.personalEnableActivity"
              >投票、讨论、抢答、评分,教师N个动作,那么系统累计N个动作</el-checkbox
            >
          </div>
        </div>
        <div class="one-weight">
          <span class="weight-name">个人章节知识成绩:</span>
          <el-input-number
            size="small"
            v-model="form.personalZsRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,个人章节知识成绩=100/题目个数*正确个数"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
          <!-- <div class="weight-content">
            <el-checkbox v-model="form.radio">单选题</el-checkbox>
            <el-checkbox v-model="form.checkbox">多选题</el-checkbox>
            <el-checkbox v-model="form.boolean">判断题</el-checkbox>
          </div> -->
        </div>
        <div class="one-weight">
          <span class="weight-name">个人章节技能成绩:</span>
          <el-input-number
            size="small"
            v-model="form.personalJnRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="个人章节技能分数=团队作品分数*(组长评分*组长权重+组员均分*权重)/100"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
          <div class="weight-content">
            <h4 style="margin-bottom: 10px">个人作品得分</h4>
            <p style="margin-bottom: 10px">
              学生评分均分*学生权重
              <el-input-number
                size="small"
                v-model="form.personalJnStudentRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
            <p style="margin-bottom: 10px">
              教师评分*教师权重
              <el-input-number
                size="small"
                v-model="form.personalJnTeacherRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
            <h4 style="margin-bottom: 10px">团队作品得分</h4>
            <p style="margin-bottom: 10px">
              组长评分*组长权重
              <el-input-number
                size="small"
                v-model="form.personalJnTeamCaptainRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
            <p style="margin-bottom: 10px">
              组员均分*组员权重
              <el-input-number
                size="small"
                v-model="form.personalJnTeamStudentRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
          </div>
        </div>

        <div class="one-weight">
          <span class="weight-name">个人章节素养成绩:</span>
          <el-input-number
            size="small"
            v-model="form.personalSyRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="每个章节学生默认成绩为满分,教师进行局部加减分"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
      </div>

      <!-- 团队章节考核权重设置 -->
      <div class="team-chapter-weight" v-if="activeStep == 2">
        <div class="one-weight">
          <span class="weight-name">团队章节态度成绩:</span>
          <el-input-number
            size="small"
            v-model="form.teamTdRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,团队章节态度成绩=团队成员个人章节态度成绩平均值"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">团队章节知识成绩:</span>
          <el-input-number
            size="small"
            v-model="form.teamZsRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新,团队章节知识成绩=团队成员个人章节知识成绩平均值"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
        <div class="one-weight">
          <span class="weight-name">团队章节技能成绩:</span>
          <el-input-number
            size="small"
            v-model="form.teamJnRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="团队章节的个人技能成绩=团队成员个人章节技能成绩平均值，自动更新"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
          <div class="weight-content">
            <h4 style="margin-bottom: 10px">团队作品得分</h4>
            <p style="margin-bottom: 10px">
              各组长评分均分*学生权重
              <el-input-number
                size="small"
                v-model="form.teamJnStudentRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
            <p style="margin-bottom: 10px">
              教师评分*教师权重
              <el-input-number
                size="small"
                v-model="form.teamJnTeacherRate"
                :min="0"
                :max="100"
                :controls="false"
              ></el-input-number>
              %
            </p>
          </div>
        </div>
        <div class="one-weight">
          <span class="weight-name">团队章节素养成绩:</span>
          <el-input-number
            size="small"
            v-model="form.teamSyRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
          <p class="tips">
            <span class="total">满分: 100</span
            ><el-tooltip
              placement="top"
              content="自动更新，团队章节素养成绩=团队成员个人章节素养成绩平均值"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
      </div>

      <!-- 实战技能考核权重设置 -->
      <div class="industry-chapter-weight" v-if="activeStep == 3">
        <div class="one-weight">
          <span class="weight-name">实战技能总分:</span>
          <el-input-number
            size="small"
            v-model="form.douyinTotalScore"
            :min="0"
            :controls="false"
          ></el-input-number>
        </div>
        <div class="one-weight">
          <span class="weight-name">抖音粉丝数权重:</span>
          <el-input-number
            size="small"
            v-model="form.douyinFansRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
        </div>
        <div class="one-weight">
          <span class="weight-name">抖音播放数权重:</span>
          <el-input-number
            size="small"
            v-model="form.douyinPlayRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
        </div>
        <div class="one-weight">
          <span class="weight-name">抖音评论数权重:</span>
          <el-input-number
            size="small"
            v-model="form.douyinCommentRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
        </div>
        <div class="one-weight">
          <span class="weight-name">抖音转发数权重:</span>
          <el-input-number
            size="small"
            v-model="form.douyinForwardRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
        </div>
        <div class="one-weight">
          <span class="weight-name">抖音点赞数权重:</span>
          <el-input-number
            size="small"
            v-model="form.douyinDiggRate"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number>
          <span style="margin: 0 15px 0 10px">%</span>
        </div>
      </div>
      <div class="btns">
        <el-button
          class="btn"
          type="primary"
          size="medium"
          v-show="activeStep > 0"
          @click="activeStep--"
          >上一步</el-button
        >
        <el-button class="btn" type="primary" size="medium" @click="handleNext">
          <span v-if="classInfo.douyin && activeStep == 3">提交</span>
          <span v-else-if="!classInfo.douyin && activeStep == 2">提交</span>
          <span v-else>下一步</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { setClassWeight } from "@/api/class";
import { classInfo } from "@/api/class";

export default {
  props: {
    classId: Number,
    hideBack: Boolean,
    isEdit: Boolean,
    weightInfo: Object,
  },
  data() {
    return {
      activeStep: 0,
      weightItems: [
        {
          name: "团队实时排行榜",
          text: "teamScoreRate",
          tips: "自动更新,团队实时成绩=团队章节成绩平均分<br />团队章节成绩=团队态度成绩*权重+团队知识成绩*权重+团队技能成绩(如有)*权重+团队素养成绩*权重<br />",
          more: '注:当所有团队章节成绩生成时,自动切换成"团队期末成绩"',
        },
        {
          name: "个人实时排行榜",
          text: "personalScoreRate",
          tips: "自动更新,个人实时成绩=个人章节成绩平均分<br />个人章节成绩=个人态度成绩*权重+个人知识成绩*权重+个人技能成绩(如有)*权重+个人素养成绩*权重<br />",
          more: '注:当所有个人章节成绩生成且期末成绩生成且教师考核成绩生成时,自动切换成"个人期末成绩"<br />个人期末成绩=团队期末成绩*权重+个人实时成绩终值*权重+期末成绩*权重+教师综合评价*权重',
        },
        {
          name: "个人期末考试成绩",
          text: "personalEndScoreRate",
          tips: "数据来自系统期末考试成绩或教师导入线下考试成绩",
          more: "",
        },
        {
          name: "个人教师综合评价",
          text: "teacherZhpjRate",
          tips: "教师对学生进行学期综合评价,评定成绩,然后导入到系统",
          more: "",
        },
      ],
      form: {
        classId: this.classId,
        teamScoreRate: 20,
        personalScoreRate: 30,
        personalEndScoreRate: 40,
        teacherZhpjRate: 10,
        personalTdRate: 20,
        personalEnableVideo: true,
        personalEnablePpt: true,
        personalEnableSign: true,
        personalEnableNotes: true,
        personalEnableWorks: true,
        personalEnableWorksInteract: true,
        personalEnableActivity: true,
        personalZsRate: 20,
        // radio: true,
        // checkbox: true,
        // boolean: true,
        personalJnRate: 50,
        personalJnStudentRate: 30,
        personalJnTeacherRate: 70,
        personalJnTeamCaptainRate: 60,
        personalJnTeamStudentRate: 40,
        personalSyRate: 10,
        teamTdRate: 20,
        teamZsRate: 20,
        teamJnRate: 50,
        teamJnStudentRate: 30,
        teamJnTeacherRate: 70,
        teamSyRate: 10,
        douyinTotalScore: 20,
        douyinFansRate: 10,
        douyinPlayRate: 30,
        douyinCommentRate: 20,
        douyinForwardRate: 10,
        douyinDiggRate: 30,
      },
      classInfo: {},
    };
  },
  created() {
    this.getClassInfo();
  },
  watch: {
    weightInfo(val) {
      if (val) this.form = val;
    },
    "form.personalJnStudentRate"(val) {
      this.form.personalJnTeacherRate = 100 - val;
    },
    "form.personalJnTeacherRate"(val) {
      this.form.personalJnStudentRate = 100 - val;
    },
    "form.personalJnTeamCaptainRate"(val) {
      this.form.personalJnTeamStudentRate = 100 - val;
    },
    "form.personalJnTeamStudentRate"(val) {
      this.form.personalJnTeamCaptainRate = 100 - val;
    },
    "form.teamJnStudentRate"(val) {
      this.form.teamJnTeacherRate = 100 - val;
    },
    "form.teamJnTeacherRate"(val) {
      this.form.teamJnStudentRate = 100 - val;
    },
  },
  computed: {
    classWeight() {
      return (
        this.form.teamScoreRate +
        this.form.personalScoreRate +
        this.form.personalEndScoreRate +
        this.form.teacherZhpjRate
      );
    },
    personalWeight() {
      return (
        this.form.personalTdRate +
        this.form.personalZsRate +
        this.form.personalJnRate +
        this.form.personalSyRate
      );
    },
    teamWeight() {
      return (
        this.form.teamTdRate +
        this.form.teamZsRate +
        this.form.teamJnRate +
        this.form.teamSyRate
      );
    },
    industryWeight() {
      return (
        this.form.douyinFansRate +
        this.form.douyinPlayRate +
        this.form.douyinCommentRate +
        this.form.douyinForwardRate +
        this.form.douyinDiggRate
      );
    },
  },
  methods: {
    getClassInfo() {
      classInfo(this.classId).then((res) => {
        if (res.code == 0) {
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    back() {
      this.$emit("back", 0);
    },
    handleNext() {
      if (this.activeStep == 0 && this.classWeight != 100) {
        this.$message.warning("班级四项权重加起来必须等于100");
        return;
      } else if (this.activeStep == 1 && this.personalWeight != 100) {
        this.$message.warning("个人四项权重加起来必须等于100");
        return;
      } else if (this.activeStep == 2 && this.teamWeight != 100) {
        this.$message.warning("团队四项权重加起来必须等于100");
        return;
      } else if (this.activeStep == 3 && this.industryWeight != 100) {
        this.$message.warning("抖音五项权重加起来必须等于100");
        return;
      } else {
        if (
          (this.activeStep == 2 && !this.classInfo.douyin) ||
          (this.activeStep == 3 && this.classInfo.douyin)
        )
          this.handleSubmit();
        else this.activeStep++;
      }
    },
    handleSubmit() {
      this.$loading.show();
      setClassWeight(this.form).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("配置成功");
          this.back();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.settings {
  .head {
    position: relative;
    padding: 20px 30px 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    height: 88px;
    text-align: left;
    background-color: #fff;
    .back {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      z-index: 99;
    }
  }
  .main {
    padding: 80px 300px;
    text-align: left;
    background-color: #fff;
    .industry-chapter-weight {
      padding-left: 120px;
    }
    .one-weight {
      margin-bottom: 20px;
      .weight-name {
        display: inline-block;
        margin-right: 10px;
        width: 145px;
        text-align: right;
      }
      .el-input-number {
        width: 80px;
      }
      .tips {
        display: inline-block;
        .total {
          margin-right: 15px;
          color: #ff0000;
        }
        .el-icon-info {
          display: inline-block;
          color: #c8c8c8;
          font-size: 18px;
          transition: color 0.3s ease;
          vertical-align: middle;
          &:hover {
            color: #1890ff;
          }
        }
      }

      .weight-content {
        margin-top: 20px;
        padding-left: 145px;
        ::v-deep .el-checkbox {
          display: block;
          margin-bottom: 15px;
          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: inherit;
          }
        }
      }
    }

    .btns {
      margin-top: 50px;
      text-align: center;
      .btn {
        margin-right: 30px;
      }
    }
  }
}
</style>